import { updateObjectsInArray } from '../../helpers';

const ACTION_APPEND = 'append';
const ACTION_REPLACE = 'replace';

export const CaseFeed = {
  state: {
    caseListLoading: false,
    caseList: [],
    pagination: {
      current_page: 1,
      per_page: 50,
      total: 0,
      last_page: 0,
    },
  },
  getters: {
    getCaseList: (state) => {
      return state.caseList;
    },
    getPaginationData: (state) => {
      return state.pagination;
    },
  },
  mutations: {
    feedSetFollowingCase(state, caseId) {
      state.caseList = updateObjectsInArray(state.caseList, caseId, 'id', { following: true });
    },
    feedSetUnFollowingCase(state, caseId) {
      state.caseList = updateObjectsInArray(state.caseList, caseId, 'id', { following: false });
    },
    setCaseList(state, caseList) {
      state.caseList.push(...caseList);
    },
    replaceCaseList(state, caseList) {
      state.caseList = caseList;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.current_page = currentPage;
    },
    setCasePagination(state, pagination) {
      state.pagination = {
        ...state.pagination,
        current_page: pagination.current_page,
        per_page: pagination.per_page,
        total: pagination.total,
        last_page: pagination.last_page,
      };
    },
    setCaseListBusy(state, loading) {
      state.caseListLoading = loading;
    },
  },
  actions: {
    changeCurrentPage({ commit, dispatch }, page = 1) {
      commit('setCurrentPage', page);
      dispatch('requestCaseFeed', { page: page, action: ACTION_REPLACE });
    },

    async requestCaseFeed({ state, dispatch, commit, getters, rootState }, { page = null, action = ACTION_APPEND }) {
      if (state.pagination.current_page !== state.pagination.last_page || action === ACTION_REPLACE) {
        if (!state.caseListLoading) dispatch('setCaseListBusy', true);

        if (page !== null) {
          commit('setCurrentPage', page);
        }

        let currentPage = state.pagination?.current_page ?? 1;
        let perPage = state.pagination?.per_page ?? 50;
        let filters = getters.getFiltersObject;
        let list = [];
        let meta = {};

        try {
          const {
            data: { data: feed, meta: resMeta },
          } = await this._vm.$api('users.case-get-feed', {
            version: '1.0',
            radiologist: rootState.currentUser,
            page: currentPage,
            filters: filters,
            perPage,
          });
          list = feed;
          meta = resMeta;
        } catch (err) {
          console.error(err);
        }

        if (action === ACTION_APPEND) {
          commit('setCaseList', list);
        }

        if (action === ACTION_REPLACE) {
          commit('replaceCaseList', list);
        }

        commit('setCasePagination', meta);
        dispatch('setCaseListBusy', false);
      }
    },

    updatePagination({ commit }, pagination) {
      commit('setCasePagination', pagination);
    },

    setCaseListBusy({ commit }, value) {
      commit('setCaseListBusy', value);
    },
  },
};
